import {createSlice } from '@reduxjs/toolkit'
import { roleId } from '../Components/Constants/app'

const UserSlice = createSlice({
    name: "UserSlice",
    initialState: {
        User: {},
        //Server: 'http://localhost:1337/', 
        //Server: 'http://79.174.81.157:1337/',
        Server: 'https://sushibox-corp.ru/api/',
        LogOut: false,
        ArrayUsers: [],
    },
    reducers: {
       setUser(state, actions){
        state.User = actions.payload
        if(![roleId.admin, roleId.operatingDirector].includes(state.User.user.role.id) && state.User.user.idCity !== 'all')
            state.User.user.idCity = state.User.user.idCity.split('_')
       },
       clearUser(state){
        state.User = {}
       },
       setLogOut(state, actions){
        state.LogOut = actions.payload
       },
       addUsers(state, actions){
        state.ArrayUsers = actions.payload
       }
    }
})

export default UserSlice.reducer
export const { setUser, clearUser, setLogOut, addUsers } = UserSlice.actions